import React, {useContext} from "react";
import {Store} from "../../../app/stores/store-root";
import {NavLink, useHistory} from "react-router-dom";
import {UserProfile} from "../../../app/models/user-profile";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";
import {EuiButton} from "@elastic/eui";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";

export const useInMemoryListConfiguration = () => {
    const store = useContext(Store);
    const history = useHistory();

    const actions: any[] = [
        {
            name: 'Pay Balance',
            description: 'Pay Balance',
            icon: 'wrench',
            type: 'icon',
            onClick: (values: any) => {
                history.push('orders/balance')
            },
        }];

    const tools = () => {
        return [
            <EuiButton
                key="loadUsers"
                size="s" fill
                onClick={() => {
                    history.push('/agents/create')
                }}
            >
                New User Profile
            </EuiButton>
        ];
    };

    const fields = [
        {
            field: 'UserName',
            name: 'User Name',
            sortable: true,
            truncateText: true,
            render: (reference: string) => {
                return (<NavLink to={`agents/edit/${reference}`}>
                    {reference}
                </NavLink>)
            }
        },
        {
            field: 'FamilyName',
            name: 'Name',
            truncateText: true,
            render: (value: any, item: UserProfile) => {
                return `${item.Name} ${value}`
            }

        },
        {
            field: 'Role',
            name: 'Role',
            truncateText: true,
            sortable: true,

        },
        {
            field: 'Phone',
            name: 'Phone',
            truncateText: true,
        },
        {
            field: 'Limit',
            name: 'Limit',
            truncateText: true,
            render: (value: any, item: UserProfile) => {
                console.log(item.Country)
                if (item.Role == 'RECEIVE_AGENT')
                    return 'Not Applicable'
                const country = store.Lookups.countryRegistry.find(country => country.label === item.Country);
                return `${country?.currencySymbol} ${value} (${country?.currencyCode})`
            }
        },
        {
            field: 'Balance',
            name: 'Balance',
            truncateText: true,
            render: (value: any, item: UserProfile) => {
                console.log(item.Country)
                if (item.Role == 'RECEIVE_AGENT')
                    return 'Not Applicable'
                if (!value)
                    return 'No orders'
                const country = store.Lookups.countryRegistry.find(country => country.label === item.Country);
                return `${country?.currencySymbol} ${value} (${country?.currencyCode})`
            }
        },
        {
            field: 'Country',
            name: 'Country',
            sortable: true,
        },
        {
            field: 'Email',
            name: 'Email',
            truncateText: true,
            sortable: true,
        },
        {
            name: 'Actions',
            actions,
        }
    ]

    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'User Profiles',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
        },
    ];

    const searchFilters: SearchFilterConfig[] = [
        {
            type: 'field_value_toggle_group',
            field: 'Role',
            items: [
                {
                    value: 'SEND_AGENT',
                    name: 'Sending Agent'
                },
                {
                    value: 'BUSINESS_ADMIN',
                    name: 'Business Administrators'
                },
                {
                    value: 'RECEIVE_AGENT',
                    name: 'Receiving Agent'
                },

            ]
        }
    ]

    const receivingViewSearchFilters: SearchFilterConfig[] = [
        {
            type: 'field_value_toggle_group',
            field: 'Role',
            items: [
                {
                    value: 'RECEIVE_AGENT_CASHIER',
                    name: 'Cashiers'
                },
                {
                    value: 'RECEIVE_AGENT_SUPERVISOR',
                    name: 'Supervisors'
                },

            ]
        }
    ];

    const searchSettings: EuiSearchBarProps = {
        toolsRight: tools(),
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: (store.Users.isReceiveAgent) ? receivingViewSearchFilters : searchFilters
    }
    return {
        actions: actions,
        fields: fields,
        breadcrumbs: breadcrumbs,
        searchSettings: searchSettings,
        tools: tools,

    }
}